import {
  Provider,
} from '@angular/core';


/**
 *
 */
export function initializeCustomProviders(): Provider[] {
  return [];
}
